import {Component} from '@angular/core';

@Component({
  selector: 'app-link-support',
  templateUrl: './link-support.component.html',
  styleUrls: ['./link-support.component.scss']
})
export class LinkSupportComponent {
}
